import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MonacoCodeEditorComponent } from '../monaco-code-editor/monaco-code-editor.component';
import { MONACO_EDITOR_OPTIONS } from 'src/app/constants/editor-options';

@Component({
  selector: 'app-editor-automation-hub',
  imports: [CommonModule, MonacoCodeEditorComponent],
  templateUrl: './editor-automation-hub.component.html',
  styleUrl: './editor-automation-hub.component.scss',
})
export class EditorAutomationHubComponent {
  @Input() code?: string = '';
  @Input() editorHeight?: number = 400;
  @Output() codeChange = new EventEmitter<string>();
  
  readonly editorOptions = MONACO_EDITOR_OPTIONS;
  
  onCodeChange(newCode: string): void {
    this.codeChange.emit(newCode);
  }
}
